import { memo } from 'react';

import type { AreaStationSummary } from './areaDetailsHelpers';

import { AreaDetailsCard } from './AreaDetailsCard';

const UNAVAILABLE_VALUE = '—';

const getDetailValue = (value: number | string | undefined): number | string =>
  value ?? UNAVAILABLE_VALUE;

type Props = {
  summary: AreaStationSummary;
  color?: string;
};

function AreaStationSummaryCardComponent({ summary, color }: Props) {
  if (summary.kind === 'rack') {
    return (
      <AreaDetailsCard
        title={summary.title}
        total={summary.stationCount}
        unitLabel='Levels'
        unitValue={getDetailValue(summary.unitCount)}
        perUnitLabel='Per level'
        perUnitValue={getDetailValue(summary.stationsPerUnit)}
        color={color}
      />
    );
  }

  return (
    <AreaDetailsCard
      title={summary.title}
      total={summary.stationCount}
      unitLabel='Stations'
      unitValue={getDetailValue(summary.unitCount)}
      perUnitLabel='Per lane'
      perUnitValue={getDetailValue(summary.stationsPerUnit)}
      color={color}
    />
  );
}

export const AreaStationSummaryCard = memo(AreaStationSummaryCardComponent);
